module.exports = __webpack_public_path__ + "img/TN.78f52d2c.png";